import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterReportTypeSelect ({ value, onChange = () => null, att }) {
  const { t } = useTranslate()

  const { reportType } = useStoreState((state) => state.filter)

  const { getReportTypeThunk } = useStoreActions((actions) => actions.filter)

  const options = _.map(reportType, (item) => {
    return {
      label: item?.report_type_name,
      value: item?.report_type_id,
    }
  })

  useAsync(async () => {
    getReportTypeThunk()
  }, [])

  return (
    <Styled className='filter-report-type-select-component'>
      <Select
        defaultValue={value}
        dropdownMatchSelectWidth={false}
        options={options}
        placeholder={t('Please select report type')}
        onChange={onChange}
        {...att}
      />
    </Styled>
  )
}
